













import {Component, Vue} from 'vue-property-decorator';
import HelpContactTile from '@/components/ui/HelpContactTile.vue';
import BoxTile from '@/components/ui/BoxTile.vue';

@Component({
    components: {BoxTile, HelpContactTile},
})
export default class Help extends Vue {

    get language() {
        return this.$store.state.lang;
    }

    get contacts() {
        if (this.$store.state.data)
            return this.$store.state.data.base_info.help_contacts
        else return [];
    }

}
